export class Requirement {
    id: number;
    description: string;

    public static fromApi(apiRequirement: any): Requirement {
        const requirement = new Requirement();
        requirement.id = apiRequirement.id;
        requirement.description = apiRequirement.description;
        return requirement;
    }
}

export default Requirement;
